/**
 * Created by Languagenut on 18/04/2019.
 */


import React  from 'react';
import {Modal , Badge , Form , Button , Card , Row , Col , Nav , ProgressBar} from 'react-bootstrap'
import ReactDOM from "react-dom";
import Papa from 'papaparse/papaparse.min.js';
import FieldGroup from '../../FieldGroup.js'
import Alert from '../../alert.js';
import downloadCsv from 'download-csv';

class CSVInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            error:false,
            loadedFile:false,
        }
    }

    downloadExample(){
        const datas = [
            { id:"ABCD123" , display_name:"Tommy" ,  frist_name: 'Tom', last_name: 'Sullivan', username:'Tom010'  , password: 'password'  , class: 'white' , another_class: 'red' },
            { id:"123ABC"  , display_name:"Paul"  ,  frist_name: 'Paul',last_name: 'Fairbank', username:'Paul1991', password: 'password'  , class: 'white' , another_class: '' },
        ];

        const columns = { display_name: 'Display Name', frist_name: 'First Name' , last_name: 'Last Name'  , username: 'Username'  , password: 'Password' , class: 'Class' , another_class: 'Second Class' };

        downloadCsv(datas, columns , 'example_import');
    }

    handleChange(e){
        var file = ReactDOM.findDOMNode(this.refs.csv).files[0];
        if(!file) return;

        Papa.parse(file, {
            error: function(err, file, inputElem, reason)
            {
                this.setState({error:err , loading:false})
            },
            complete: function(results) {
                this.props.handleFileChange(results.data);
                this.setState({error:false , loading:false , loadedFile:file})
            }.bind(this)


        });

        this.setState({
            loading:true,
            error:false
        });

    }

    render() {

        if(this.state.loading)
        {
            return  <ProgressBar animated now={100} />
        }

        let error = null;

        if(this.state.error) error = <Alert variant={'danger'}>
            {this.state.error}
        </Alert>


        let completed = null;

        console.log(this.state.loadedFile.name);
        if(this.state.loadedFile) completed = <Alert  variant={'success'}>
            File: {this.state.loadedFile.name}
        </Alert>

        let modalClose = () => this.setState({ modalShow: false });
        let modalOpen  = () => this.setState({ modalShow: true });

        /*
        *
        *
        * delimiter: "",	// auto-detect
         newline: "",	// auto-detect
         quoteChar: '"',
         escapeChar: '"',

        *
        * */
        return (
            <div>
            <Row>
                <Col md={12}>
                    <form >
                        <div className="form-group">
                            <input name="file" type="file" className="inputfile" id="file" accept=".csv" onChange={this.handleChange.bind(this)} ref="csv" />
                            <label className="btn btn-primary" for="file">&nbsp;<i class="fas fa-upload"></i>&nbsp;<strong>Choose a file</strong></label>
                          </div>
                    </form>


                </Col>
            </Row>

                {completed}
                {error}
            </div>
        );
    }
};

class UploadStudentsCSV extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {
            licences:10,
            totalLicences:200,
            totalToMake:0,
            isMake:true,
        };
        this.props.data.isMake = true;
    }

    calculateLicencesRemaining(size){
        return Number(this.state.licences) - Number(size)
    };

    handleFileChange(csv) {
        this.props.data.csv = csv;
        this.setState({totalToMake:this.props.data.csv.length});
    }

    changeMode(bool){
        this.props.data.isMake = bool;
        this.setState({isMake:bool})
    }



    render(){



        return <div style={{padding:"20px"}}>
            <Card.Title>Student Import  <small><i class="fas fa-chevron-right"></i></small>   Step 1: Select Data</Card.Title>
            <br/>
                            <div >
                                <CSVInput handleFileChange={this.handleFileChange.bind(this)} data={this.state.data} />
                            </div>

                    </div>
    }


}


export default {
    name: "Upload File",
    icon:<i class="fa-2x fas fa-upload"></i>,
    title:null,
    onSubmit: function (done){

        if(!this.props.data.csv) return done({message:"Sorry but you haven't uploaded a valid CSV"});
        if(this.props.data.csv.length <= 0) return done({message:"Sorry but your CSV file is empty"});
        if(this.props.data.csv.length >= 5000) return done({message:"Sorry but maximum students that can be uploaded at a time is 5000"});

        done();
    },
    onBack:function(done){
        done();
    },
    component: UploadStudentsCSV
}